import { useTranslation } from 'react-i18next'
import { values } from 'ramda'
import useBasic from '@/hooks/use-basic'

const identity = (value: string) => value

const fallback =
  (next = identity) =>
  (value?: string) =>
    value ? next(value) : '-'

const obfuscate = (count: number) => '*'.repeat(count)

export const formatAccountNumberShort = fallback((value: string) =>
  value.substring(value.length - 4)
)

export const formatObfuscatedAccountNumber = (value: string, obfuscateCount?: number) =>
  value ? obfuscate(obfuscateCount || 2) + value.substring(value.length - 4) : '-'

export const formatAccountNumber = fallback(
  (value: string) => obfuscate(8) + formatAccountNumberShort(value)
)

export const formatTransitNumber = fallback(
  (value: string) => obfuscate(3) + value.substring(value.length - 2)
)

export const useBank = (value?: string): string => {
  const { financial_institutions } = useBasic(['financial_institutions'])
  const banks = values(financial_institutions)
  const bank = banks.find(({ txt_id }: { txt_id?: string }) => txt_id === value)
  const bankName = bank?.name || value || 'Other'
  return bankName
}

type Bank = {
  id: string
  name: string
  txt_id: string
  fin: string
}

export const getBankName = (value: string, bankList: Record<string, Bank>): string => {
  const banks = values(bankList)
  const bank = banks.find(({ txt_id }: { txt_id?: string }) => txt_id === value)
  const bankName = bank?.name || value || 'Other'
  return bankName
}

export const useAccountType = (value?: string): string => {
  const { t } = useTranslation()
  const accountTypes: Record<string, string> = {
    checking: t('l.payment_settings.edit.checking_account.label', 'Chequing account'),
    savings: t('l.payment_settings.edit.savings_account.label', 'Savings account')
  }
  const account = accountTypes[value || '']
  return fallback()(account)
}
